export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.11-1540.29",
  commitId: "d4f4475f5a57c754192dbc3a92c6bf657ea2df50",
  commitTime: "2026-08-11T15:40:29.000Z",
});
